import React from "react";
import {
    FaTrophy,
    FaAward,
    FaGraduationCap,
    FaCalendarCheck,
    FaDownload,
} from "react-icons/fa";
import styles from "./AwardPage.module.css";

const AwardPage = () => {
    const deadline = "31-Dec-2026";

    const awards = [
        {
            id: "pierce-award",
            badge: "EXCELLENCE AWARD",
            title: "John R. Pierce Award for Excellence in Vacuum Electronics",
            icon: <FaTrophy />,
            paragraphs: [
                "The John R. Pierce Award for Excellence in Vacuum Electronics (former IVEC Award) was established in 2002 to recognize outstanding contributions to the field. Anyone or any group of professionals working in the field of vacuum electronics is eligible for this award, which is presented every year during the IVEC conference.",
                "The winner will receive a commemorative plaque and prize money of USD 2000. If a group nomination is selected for the award they will each receive a plaque and share the USD 2000."
            ],
            detailsUrl: "https://vacuumelectronics.org/ivecaward.html",
            contact: {
                name: "Dr. Dan M. Goebel",
                email: "dan.m.goebel@jpl.nasa.gov",
            },
        },
        {
            id: "young-scientist",
            badge: "EARLY CAREER",
            title: "Vacuum Electronics Young Scientist Award (VEYS)",
            icon: <FaAward />,
            paragraphs: [
                "The Vacuum Electronics Young Scientist Award (VEYS) is aimed to recognize outstanding contributions from early career researchers and young professionals in the field of Vacuum Electronics.",
                "This award recognizes technical achievements, leadership in service, education, innovation and entrepreneurship. This Award is presented every year at the International Vacuum Electronics Conference (IVEC). The prize comprises prize money of USD 1000 and a plaque."
            ],
            detailsUrl: "https://vacuumelectronics.org/veysaward.html",
            contact: {
                name: "Prof. Eunmi Choi (UNIST, South Korea)",
                email: "emchoi@unist.ac.kr",
            },
        },
    ];

    const handleDownloadForm = () => {
        const link = document.createElement('a');
        link.href = '/documents/Declaration Form_Best Student Paper Award.doc';
        link.download = 'Declaration Form_Best Student Paper Award.doc';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.contentWrapper}>
                {/* Header Section */}
                <header className={styles.header}>
                    <span className={styles.topBadge}>HONORS & RECOGNITION</span>
                    <h1 className={styles.title}>Call for Award Nominations</h1>
                    <p className={styles.subtitle}>
                        Nominations are solicited for prestigious IEEE EDS Vacuum Electronics Technical Committee awards.
                    </p>
                </header>

                {/* Major Awards Grid */}
                <div className={styles.awardsGrid}>
                    {awards.map((award) => (
                        <div key={award.id} className={styles.awardCard}>
                            <div className={styles.cardHeader}>
                                <div className={styles.iconWrapper}>{award.icon}</div>
                                <span className={styles.cardBadge}>{award.badge}</span>
                            </div>
                            <h2 className={styles.awardTitle}>{award.title}</h2>

                            <div className={styles.textBody}>
                                {award.paragraphs.map((p, idx) => (
                                    <p key={idx} className={styles.awardParagraph}>{p}</p>
                                ))}
                            </div>

                            <div className={styles.awardFooter}>
                                <p className={styles.detailsLinkText}>
                                    <strong>For details visit:</strong>{" "}
                                    <a href={award.detailsUrl} target="_blank" rel="noopener noreferrer">
                                        {award.detailsUrl}
                                    </a>
                                </p>
                                <div className={styles.contactBox}>
                                    <p className={styles.contactTitle}>
                                        Contact at Vacuum Electronics Technical Committee (IEEE-VETC):
                                    </p>
                                    <p className={styles.contactDetail}>{award.contact.name}</p>
                                    <p className={styles.contactDetail}>
                                        Email: <a href={`mailto:${award.contact.email}`}>{award.contact.email}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Student Paper Award Feature Box */}
                <div className={styles.studentFeatureCard}>
                    <div className={styles.studentHeader}>
                        <div className={styles.studentIconWrapper}>
                            <FaGraduationCap />
                        </div>
                        <div>
                            <span className={styles.studentBadge}>STUDENT PRIZE</span>
                            <h2 className={styles.studentTitle}>IVEC Best Student Paper Award</h2>
                        </div>
                    </div>

                    <div className={styles.textBody}>
                        <p className={styles.studentParagraph}>
                            The IVEC Best Student Paper Award was introduced at IVEC 2004 to recognize and promote exceptional student contributions to the field.
                        </p>
                        <p className={styles.studentParagraph}>
                            IVEC 2027 will continue the tradition of selecting an outstanding, student-authored and student-presented paper and recognize it. Eligible papers are those with a student as the first author and presenter. Students are considered as individuals pursuing a baccalaureate or graduate degree at the time of the conference or during the past year when the work was completed.
                        </p>
                        <p className={styles.studentParagraph}>
                            After ranking by the Technical Program Committee, a few student papers are selected for finalist consideration. Finalist students will present a 10 minute synopsis talk on their work in a special session during the conference, and from these brief summary talks a winner will be selected. The award includes a certificate and USD 500 prize money.
                        </p>
                    </div>

                    <div className={styles.studentContactSection}>
                        <p className={styles.studentRequirementText}>
                            <strong>The student first-author of the paper, willing to participate in the competition, need to forward a declaration to the Award Committee as per the following format.</strong>
                        </p>
                        <p className={styles.contactTitle}>
                            Contact at Vacuum Electronics Technical Committee (IEEE-VETC):
                        </p>
                        <p className={styles.contactDetail}>Prof. S. Yuvaraj</p>
                        <p className={styles.contactDetail}>Indian Institute of Information Technology, Kancheepuram, India</p>
                        <p className={styles.contactDetail}>
                            Email: <a href="mailto:yuvaraj@iiitdm.ac.in">yuvaraj@iiitdm.ac.in</a>
                        </p>
                    </div>

                    <div className={styles.studentActionRow}>
                        <button className={styles.downloadBtn} onClick={handleDownloadForm}>
                            <FaDownload className={styles.btnIcon} /> Declaration Form
                        </button>
                        <div className={styles.deadlineInfo}>
                            <FaCalendarCheck className={styles.deadlineIcon} />
                            <span>Deadline for submitting the declaration: <strong>{deadline}</strong></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AwardPage;